import { useTranslation } from 'react-i18next';
import { formatDate } from '~/common/utils/dateUtil';
import type { BghArticleDetail } from '~/common/types/bghArticleDetail';
import { cn } from '~/common/utils/styleUtil';
import type {AghArticleDetail} from "~/common/types/aghArticleDetail.ts";

interface RecentOrderProps {
  article: BghArticleDetail | AghArticleDetail;
  isAgh?: boolean;
}

export function RecentOrder({ article, isAgh = false }: Readonly<RecentOrderProps>) {
  const { t } = useTranslation();

  if (!article.recentOrderDate) {
    return null;
  }

  const sellUnitValue = article.sellUnit;
  const articleUnitValue = article.unitText;
  const textSellUnitText =
    article.recentOrderSellAmount && article.recentOrderSellAmount > 1
      ? sellUnitValue + ` ${t('sellUnitSeparator')} `
      : '';
  const textPart2 = article.recentOrderWeight
    ? article.recentOrderWeight.toFixed(3) + ' ' + articleUnitValue
    : article.recentOrderSellAmount + ' ' + articleUnitValue;

  return (
    <div className={cn('flex mb-4 flex-col sm:flex-row desktop:items-center desktop:mb-0')}>
      <div>{t(isAgh ? 'Zuletzt gekauft am' : 'Zuletzt bestellt mit Lieferdatum am')}&nbsp;</div>
      <div data-testid="recentOrder">
        {formatDate(new Date(article.recentOrderDate))}: {article.recentOrderQuantity} x {textSellUnitText} {textPart2}
      </div>
    </div>
  );
}
